import * as React from "react";

const SvgComponent = (props:any) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <path
            d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm2.063 10.313H8.936v7.562h4.126v-7.563zM11 4.125a2.062 2.062 0 1 0 0 4.125 2.062 2.062 0 0 0 0-4.125z"
            fill="#444F5C"
            fillRule="nonzero"
        />
    </svg>
);

export default SvgComponent;
